export default __webpack_public_path__ + "static/media/CircuitTrainingHero.9fbb9e19.png";